import { I18N } from "./I18N.js"
import { Order } from "./data/Order.js"
import { ReceiptPreviewDialog } from "./ReceiptPreviewDialog"
import { Spinner } from "./Spinner.js"

export class Orders {
	_target
	_appContext

	constructor(target) {
		this._target = document.getElementById(target)
		this._target.setAttribute('hidden', '')
		this._target.innerHTML = `
			<h2 i18n>My Orders</h2>
			<div id="currentOrderSection"></div>
			<div id="orderHistoryList"></div>
			<div id="orderReceiptPreview"></div>
		`
		I18N.translateElement(this._target)
	}

	setAppContext = appContext => this._appContext = appContext

	setVisible = visible => {
		if (visible) {
			this._target.removeAttribute('hidden')
			this._render()
		} else {
			this._target.setAttribute('hidden', '')
		}
	}

	_render = () => {
		this._renderCurrentOrder()
		this._renderHistory()
	}

	_renderCurrentOrder = () => {
		const section = document.getElementById('currentOrderSection')
		const processInstanceId = localStorage.getItem('processInstanceId')
		if (!processInstanceId) {
			section.innerHTML = ''
			return
		}
		fetch(`/receipt/${processInstanceId}`)
			.then(r => r.ok ? r.json() : null)
			.catch(() => null)
			.then(receipt => {
				const shortId = processInstanceId.substring(0, 8)
				const statusBtnId = `currentOrderStatusBtn`
				if (receipt) {
					// Ein Receipt existiert nur für bereits abgeschlossene Bestellungen (siehe
					// storeclient Counter.js: POST /receipt erst nach Auftragsannahme/-abschluss).
					// processInstanceId hier trotzdem noch gesetzt zu finden bedeutet, dass die
					// Bereinigung beim Prozessabschluss (Confirmation.js) verpasst wurde (z.B. Reload
					// vor Eintreffen des Websocket-Updates) — nachholen, damit die Bestellung nicht
					// weiter fälschlich als "Laufende Bestellung" erscheint.
					localStorage.removeItem('processInstanceId')
					section.innerHTML = ''
					this._renderHistory()
					return
				} else {
					section.innerHTML = `
						<div class="card">
							<strong i18n>Current Order</strong>
							<div>${shortId} &middot; <span i18n>In progress</span></div>
							<div class="btnGroup">
								<button id="${statusBtnId}" class="primary" i18n>Show status</button>
							</div>
						</div>
					`
					I18N.translateElement(section)
				}
				document.getElementById(statusBtnId).addEventListener('click', () => {
					this._appContext.setActive('confirmation')
				})
			})
	}

	_renderHistory = () => {
		const list = document.getElementById('orderHistoryList')
		const currentId = localStorage.getItem('processInstanceId')
		const history = JSON.parse(localStorage.getItem('orderHistory') || '[]')
			.filter(e => e.id !== currentId)
		if (!history.length) {
			list.innerHTML = ''
			return
		}
		list.innerHTML = ''
		const spinner = new Spinner(list, 15)
		Promise.all(
			history.map(({ id }) =>
				fetch(`/receipt/${id}`)
					.then(r => r.ok ? r.json() : null)
					.catch(() => null)
			)
		).then(receipts => {
			spinner.dismiss()
			const valid = receipts.filter(Boolean)
			if (!valid.length) {
				list.innerHTML = ''
				return
			}
			const rows = valid.map(receipt => {
				const date = new Date(receipt.createdAt)
				const dateStr = date.toLocaleString('de-DE', { dateStyle: 'short', timeStyle: 'short' })
				const amount = `${(receipt.totalAmount || 0).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €`
				const btnId = `receiptBtn_${receipt.processInstanceId.replace(/-/g, '').substring(0, 8)}`
				// "rejected" (nie angenommen) vs. "cancelled" (erst angenommen, dann storniert) -
				// unterscheiden sich für den Kunden in der Bedeutung, siehe receipt.wasAccepted.
				const cancelledLabel = receipt.cancelled ? (receipt.wasAccepted ? 'cancelled' : 'rejected') : null
				return `<tr${receipt.cancelled ? ' class="cancelledOrderRow"' : ''}>
					<td>${receipt.processInstanceId.substring(0, 8)}</td>
					<td>${dateStr}</td>
					<td class="priceColumn">${amount}</td>
					<td>${cancelledLabel ? `<span class="cancelledTag" i18n>${cancelledLabel}</span>` : ''}</td>
					<td><button id="${btnId}" class="primary" i18n>${receipt.cancelled ? 'Receipt preview' : 'Receipt'}</button></td>
				</tr>`
			}).join('')
			list.innerHTML = `
				<table class="priceTable">
					<thead><tr>
						<td i18n>Order</td>
						<td i18n>Date</td>
						<td i18n>Amount</td>
						<td></td>
						<td></td>
					</tr></thead>
					<tbody>${rows}</tbody>
				</table>
			`
			I18N.translateElement(list)
			valid.forEach(receipt => {
				const btnId = `receiptBtn_${receipt.processInstanceId.replace(/-/g, '').substring(0, 8)}`
				document.getElementById(btnId).addEventListener('click', () => {
					const order = new Order(receipt.processInstanceId)
					const od = receipt.orderData
					order.setOrder({
						...od,
						receiveDate: od.receiveDate ? new Date(od.receiveDate) : null,
						deliveryDate: od.deliveryDate ? new Date(od.deliveryDate) : null,
					})
					order.setCart(od.cart)
					const store = od.storeReceiptImageUrl ? { receiptImageUrl: od.storeReceiptImageUrl } : null
					// A cancelled order was never actually fulfilled - the invoice number was
					// already reserved at acceptance time but the sale didn't happen, so this
					// must never be presented as a real receipt, only as a preview.
					new ReceiptPreviewDialog('orderReceiptPreview', order, store, receipt.cancelled ? 'Receipt preview' : 'Receipt').setVisible(true)
				})
			})
		})
	}
}
